export default function Services() {
  const services = [
    {
      title: 'Residential Roofing',
      description: 'Complete roofing solutions for your home including repairs, replacements, and new installations',
      icon: 'ri-home-4-line',
      image: 'https://public.readdy.ai/ai/img_res/ed95cc055411b5882bb84720693b9455.jpg',
      features: ['Roof Repair', 'Roof Replacement', 'New Roof Installation', 'Emergency Services']
    },
    {
      title: 'Commercial Roofing',
      description: 'Professional roofing services for commercial properties with minimal business disruption',
      icon: 'ri-building-line',
      image: 'https://readdy.ai/api/search-image?query=modern-commercial-building-with-professional-flat-roof-installation-business-property-industrial-roofing-system-clean-architectural-design-urban-setting-professional-construction-quality-materials&width=600&height=400&seq=service-002&orientation=landscape',
      features: ['Flat Roofing', 'Metal Roofing', 'TPO & EPDM', 'Maintenance Plans']
    },
    {
      title: 'Additional Services',
      description: 'Complete exterior solutions including gutters, siding, windows, and more',
      icon: 'ri-tools-line',
      image: 'https://readdy.ai/api/search-image?query=house-exterior-showing-quality-gutters-soffit-fascia-and-siding-installation-professional-home-improvement-work-clean-modern-exterior-details-well-maintained-property-natural-daylight-high-quality-craftsmanship&width=600&height=400&seq=service-003&orientation=landscape',
      features: ['Gutters Installation', 'Soffit & Fascia', 'Siding', 'Windows']
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-orange-100 text-orange-600 rounded-full text-sm font-semibold mb-4">
            OUR EXPERTISE
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Professional Roofing Solutions
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We specialize in roof repairs, replacements, and inspections to protect your home or business
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group"
            >
              {/* Image */}
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
                <div className="absolute bottom-4 left-4">
                  <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center">
                    <i className={`${service.icon} text-2xl text-white`}></i>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-gray-600 mb-4 text-sm leading-relaxed">{service.description}</p>
                
                {/* Features List */}
                <ul className="space-y-2 mb-6">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm text-gray-700">
                      <i className="ri-check-line text-orange-500 font-bold"></i>
                      {feature}
                    </li>
                  ))}
                </ul>

                <button
                  onClick={() => {
                    const element = document.getElementById('contact');
                    element?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="w-full py-3 bg-gray-900 hover:bg-orange-500 text-white font-semibold rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  Get Quote
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6">
            <strong>Free inspection, repair, replace, and install new roof.</strong> We also install gutters, soffit, fascia, siding, windows and more.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={() => {
                const element = document.getElementById('free-inspection');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              Schedule Free Inspection
            </button>
            <a
              href="tel:4172295037"
              className="px-8 py-4 bg-gray-900 hover:bg-gray-800 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill mr-2"></i>
              (417) 229-5037
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
